import {createSelector} from 'reselect';
import {getLocale} from './system';
import {getMap, getSystem, getTranslations} from './store';
import {getGeoCode, getGeography, getPropertyMapThumbnailUrl, getPropertyNotes} from './listing';
import getListingPageModalStates from './modalStates';
import {getLocation} from './listingSummary';

const getLocationDescription = createSelector(
    [getPropertyNotes],
    (propertyNotes = []) => {
        for (let note of propertyNotes) {
            if (note.title === 'Local Description' && note.text && note.text.trim().length) {
                return note.text;
            }
        }

        return null;
    }
);

const getMapThumbnailAlt = createSelector(
    [getTranslations],
    (translations) => {
        return {
            propertyMapThumbnailAlt: translations.propertyMapThumbnailAlt
        };
    }
);

const getMapData = createSelector(
    [
        getLocale,
        getLocation,
        getLocationDescription,
        getMap,
        getGeoCode,
        getGeography,
        getSystem,
        getTranslations,
        getPropertyMapThumbnailUrl,
        getListingPageModalStates
    ],
    (
        locale,
        locationLabel,
        locationDescription,
        map,
        geoCode,
        geography,
        system,
        translations,
        propertyMapThumbnailUrl,
        listingPageModalStates
    ) => {
        const mapRegion = locale.substring(3, 5);
        const location = (geography && geography.location) || {};
        const geo = geoCode || {};
        const lat = geo.latitude || location.lat;
        const lng = geo.longitude || location.lng;
        const exact = !!(geo.latitude && geo.longitude && geo.exact);

        let mapLabel = translations.navMap;
        let labels = {
            openMap: translations.openMap,
            map: mapLabel,
            location: locationLabel,
            more: translations.more
        };

        labels.mapLabel = translations.navLocation;
        labels.toi = {
            detailedlocation: translations.toiDetailedLocation,
            distance: {
                fromrental: translations.toiDistanceFromrental
            },
            location: mapLabel,
            pagination: {
                next: translations.toiPaginationNext,
                of: translations.toiPaginationOf,
                prev: translations.toiPaginationPrev
            },
            rated: translations.toiRated,
            whatsnearby: translations.toiWhatsnearby
        };

        const toiModalOpen = listingPageModalStates.toiModalOpen;
        const locationModalOpen = listingPageModalStates.locationModalOpen;

        return {
            unveiled: map.unveiled,
            exact,
            lat,
            lng,
            locationDescription,
            mapApiKey: map.apiKey,
            mapLanguage: locale,
            propertyMapThumbnailUrl,
            mapRegion,
            labels,
            siteName: system.siteName,
            toiModalOpen,
            locationModalOpen
        };
    }
);

export default getMapData;
export {getMapData, getLocationDescription, getMapThumbnailAlt};
